import { useState, useEffect, useContext } from "react";
import ContatServices from "../services/contactServices";
import { AuthContext } from '../contexts/AuthContext';

export default function useDiscussion() {
  const { api } = useContext(AuthContext);
  const service = new ContatServices(api);
  
  const contactAdmin = async (data) => {
    const res = await service.contactAdmin(data);
    return res.data.data;
  };

  return {
    contactAdmin
  };
}
